export const REQUEST_DATA = 'REQUEST_DATA';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const REQUEST_LANDING = 'REQUEST_LANDING';
export const RECEIVE_LANDING = 'RECEIVE_LANDING';
export const REQUEST_INDICATOR_META = 'REQUEST_INDICATOR_META';
export const RECEIVE_INDICATOR_META = 'RECEIVE_INDICATOR_META';
export const RESET_DATA = 'RESET_DATA';
export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const SET_UI_FLAG = 'SET_UI_FLAG';



// WEBPACK FOOTER //
// ./app/config/types.js